if (!customElements.get('tt-sound-library')) {
  class TitronicSoundLibrary extends HTMLElement {
    connectedCallback() {
      this.toggles = Array.from(this.querySelectorAll('[data-role="toggle"]'));
      this.bars = this.querySelector('[data-role="wave-bars"]');
      this.playButton = this.querySelector('[data-role="play"]');
      this.playIcon = this.querySelector('[data-role="play-icon"]');
      this.metaLabel = this.querySelector('[data-role="meta"]');
      this.audio = this.querySelector('[data-role="audio"]');

      this.toggles.forEach((toggle) => {
        toggle.addEventListener('click', () => this.activate(toggle));
      });

      if (this.playButton) {
        this.playButton.addEventListener('click', () => this.togglePlay());
      }

      if (this.audio) {
        this.audio.addEventListener('ended', () => this.setPlaying(false));
      }

      const initial = this.toggles.find((toggle) => toggle.classList.contains('is-active')) || this.toggles[0];
      if (initial) this.activate(initial, { skipReset: true });
    }

    activate(toggle, { skipReset = false } = {}) {
      this.toggles.forEach((t) => t.classList.toggle('is-active', t === toggle));

      const values = (toggle.dataset.wave || '')
        .split(',')
        .map((value) => value.trim())
        .filter(Boolean);
      this.renderWave(values);

      if (this.metaLabel && toggle.dataset.meta) {
        this.metaLabel.textContent = toggle.dataset.meta;
      }

      if (this.audio) {
        const src = toggle.dataset.audio || '';
        if (this.audio.getAttribute('src') !== src) {
          this.audio.setAttribute('src', src);
        }
        if (!skipReset) this.setPlaying(false);
      }
    }

    renderWave(values) {
      if (!this.bars) return;
      this.bars.innerHTML = '';
      values.forEach((value) => {
        const bar = document.createElement('span');
        bar.style.height = `${value}%`;
        this.bars.appendChild(bar);
      });
    }

    togglePlay() {
      if (!this.audio || !this.audio.getAttribute('src')) return;
      if (this.audio.paused) {
        this.audio.play();
        this.setPlaying(true);
      } else {
        this.audio.pause();
        this.setPlaying(false);
      }
    }

    setPlaying(isPlaying) {
      if (this.playIcon) {
        this.playIcon.innerHTML = isPlaying
          ? '<svg viewBox="0 0 24 24" fill="#0B0C0E"><rect x="6" y="5" width="4" height="14"/><rect x="14" y="5" width="4" height="14"/></svg>'
          : '<svg viewBox="0 0 24 24" fill="#0B0C0E"><path d="M6 4l14 8-14 8z"/></svg>';
      }
    }
  }
  customElements.define('tt-sound-library', TitronicSoundLibrary);
}
